/* ============================================================
   GRANIT ONLINE — Home Premium (model IM8) — interactivity boot
   Powers every .tvn homepage section. Idempotent, vanilla JS.
   - .tvn-reveal  → fades/slides in on scroll
   - .tvn-faq__q  → toggles .is-open on closest .tvn-faq__item
   - [data-tvn-carousel] + [data-tvn-prev/next] → scroll carousel
   - [data-count-to]    → animated number count-up on reveal
   - [data-tvn-marquee] → seamless infinite marquee (duplicates track)
   - .gp-wa-fab         → floating WhatsApp button reveal on scroll
   ============================================================ */
(function () {
  if (window.__goPremBooted) return;
  window.__goPremBooted = true;

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  ready(function () {
    /* mark .tvn roots so reveal hidden-state applies only with JS */
    document.querySelectorAll('.tvn').forEach(function (el) { el.classList.add('tvn-js'); });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- Reveal on scroll + count-up trigger ---- */
    var revealEls = document.querySelectorAll('.tvn-reveal');
    var countEls = document.querySelectorAll('[data-count-to]');
    if (reduce || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
      countEls.forEach(function (el) { el.textContent = el.getAttribute('data-count-to'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });

      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          cio.unobserve(e.target);
          runCount(e.target);
        });
      }, { threshold: 0.5 });
      countEls.forEach(function (el) { cio.observe(el); });
    }

    function runCount(el) {
      var raw = el.getAttribute('data-count-to');
      var target = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
      if (isNaN(target)) { el.textContent = raw; return; }
      var prefix = el.getAttribute('data-count-prefix') || '';
      var suffix = el.getAttribute('data-count-suffix') || '';
      var dur = 1300, t0 = null;
      var fmt = function (n) {
        var s = (target % 1 !== 0) ? n.toFixed(1) : Math.round(n).toLocaleString('hu-HU');
        return prefix + s + suffix;
      };
      var step = function (ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * eased);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    /* ---- FAQ accordion (event delegation) ---- */
    document.addEventListener('click', function (ev) {
      var q = ev.target.closest('.tvn-faq__q');
      if (!q) return;
      var item = q.closest('.tvn-faq__item');
      if (!item) return;
      var open = item.classList.contains('is-open');
      var group = item.closest('.tvn-faq');
      if (group) group.querySelectorAll('.tvn-faq__item.is-open').forEach(function (it) {
        if (it !== item) { it.classList.remove('is-open'); collapse(it); }
      });
      if (open) { item.classList.remove('is-open'); collapse(item); }
      else { item.classList.add('is-open'); expand(item); }
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    function panel(item) { return item.querySelector('.tvn-faq__a'); }
    function expand(item) { var a = panel(item); if (a) a.style.height = a.scrollHeight + 'px'; }
    function collapse(item) { var a = panel(item); if (a) a.style.height = '0px'; }

    /* ---- Carousels (supports go-prem AND tvn hooks + dots) ---- */
    document.querySelectorAll('[data-tvn-carousel]').forEach(function (root) {
      var track = root.querySelector('.tvn-carousel__track');
      if (!track) return;
      var prev = root.querySelector('[data-tvn-prev],[data-tvn-carousel-prev]');
      var next = root.querySelector('[data-tvn-next],[data-tvn-carousel-next]');
      var dotsWrap = root.querySelector('[data-tvn-carousel-dots],[data-tvn-dots]');
      var page = function () { return Math.max(track.clientWidth, 1); };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
      var dots = [];
      var buildDots = function () {
        if (!dotsWrap) return;
        var n = Math.max(1, Math.round(track.scrollWidth / page()));
        if (n === dots.length) return;
        dotsWrap.innerHTML = ''; dots = [];
        for (var i = 0; i < n; i++) {
          (function (idx) {
            var d = document.createElement('button');
            d.type = 'button'; d.className = 'tvn-dot'; d.setAttribute('aria-label', 'Slide ' + (idx + 1));
            d.addEventListener('click', function () { track.scrollTo({ left: idx * page(), behavior: 'smooth' }); });
            dotsWrap.appendChild(d); dots.push(d);
          })(i);
        }
      };
      var sync = function () {
        if (prev) prev.disabled = track.scrollLeft < 8;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
        if (dots.length) {
          var active = Math.round(track.scrollLeft / page());
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
        }
      };
      buildDots();
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', function () { buildDots(); sync(); }, { passive: true });
      sync();
    });

    /* ---- Seamless marquee (duplicate content once) ---- */
    document.querySelectorAll('[data-tvn-marquee]').forEach(function (m) {
      var inner = m.querySelector('.gp-marquee__row');
      if (inner && !inner.dataset.cloned) {
        inner.dataset.cloned = '1';
        var clone = inner.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        m.appendChild(clone);
      }
    });

    /* ---- Hero background video: aggressive muted autoplay (iOS-first) ---- */
    document.querySelectorAll('.gp-hero__vid').forEach(function (v) {
      /* Force muted-autoplay attributes (some browsers strip them) */
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.loop = true;
      v.setAttribute('loop', '');
      v.preload = 'auto';
      v.setAttribute('preload', 'auto');

      /* Remove poster attr — it causes iOS Safari to show a native play button.
         The container’s CSS background-image provides the visual fallback. */
      v.removeAttribute('poster');

      /* === SOURCE SELECTION: set v.src directly ===
         <source media="..."> is unreliable on some iOS builds.
         Picking the right file in JS and assigning v.src is bulletproof. */
      var sources = v.querySelectorAll('source');
      if (sources.length > 0) {
        var mobileSrc = '';
        var desktopSrc = '';
        sources.forEach(function (s) {
          var media = s.getAttribute('media');
          if (media) { mobileSrc = s.getAttribute('src'); }
          else if (!desktopSrc) { desktopSrc = s.getAttribute('src'); }
        });
        var hasBothSources = mobileSrc && desktopSrc;
        if (hasBothSources) {
          var isMobile = window.innerWidth <= 767;
          var targetSrc = isMobile ? mobileSrc : desktopSrc;
          while (v.firstChild) v.removeChild(v.firstChild);
          v.src = targetSrc;
        } else if (sources.length === 1) {
          v.src = sources[0].getAttribute('src');
          sources[0].remove();
        }
      }

      var playing = false;
      var retries = 0;

      var tryPlay = function () {
        if (playing && !v.paused && !v.ended) return;
        if (v.readyState < 2 && v.networkState !== 2) {
          v.load();
        }
        var p = v.play();
        if (p && p.then) {
          p.then(function () { playing = true; retries = 0; })
           .catch(function () {
              playing = false;
              if (retries < 12) {
                retries++;
                setTimeout(tryPlay, Math.min(800 * retries, 5000));
              }
           });
        }
      };

      /* === STRATEGY 1: Immediate + rapid-fire retries === */
      tryPlay();
      var earlyRetries = [100, 300, 600, 1200, 2500];
      earlyRetries.forEach(function (ms) {
        setTimeout(function () {
          if (v.paused || v.ended) tryPlay();
        }, ms);
      });

      /* === STRATEGY 2: Media events === */
      v.addEventListener('loadedmetadata', tryPlay);
      v.addEventListener('canplay', tryPlay);
      v.addEventListener('loadeddata', tryPlay);

      v.addEventListener('suspend', function () {
        if (v.paused && v.readyState < 3) {
          v.load();
          setTimeout(tryPlay, 200);
        }
      });

      v.addEventListener('ended', function () {
        v.currentTime = 0;
        tryPlay();
      });

      v.addEventListener('stalled', function () {
        setTimeout(tryPlay, 1500);
      });
      v.addEventListener('waiting', function () {
        setTimeout(tryPlay, 2000);
      });

      v.addEventListener('pause', function () {
        playing = false;
        setTimeout(function () {
          if (v.paused && !document.hidden) tryPlay();
        }, 600);
      });

      /* === STRATEGY 3: Page lifecycle events === */
      window.addEventListener('load', function () {
        if (v.paused) { retries = 0; tryPlay(); }
      });

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) { retries = 0; setTimeout(tryPlay, 250); }
      });

      setInterval(function () {
        if ((v.paused || v.ended) && !document.hidden) tryPlay();
      }, 4000);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) tryPlay(); });
        }, { threshold: 0.08 }).observe(v);
      }

      /* === STRATEGY 4: User interaction nudges (absolute last resort) === */
      var nudged = false;
      var nudge = function () {
        if (nudged) return;
        if (v.paused || v.ended) {
          retries = 0;
          tryPlay();
        }
        if (!v.paused) nudged = true;
      };
      document.addEventListener('touchstart', nudge, { passive: true });
      document.addEventListener('click', nudge, { passive: true });
      document.addEventListener('scroll', nudge, { passive: true });
    });

    /* ---- Floating WhatsApp FAB: show after first viewport ---- */
    var fab = document.querySelector('.gp-wa-fab');
    if (fab) {
      var onScroll = function () {
        if (window.scrollY > window.innerHeight * 0.6) fab.classList.add('is-visible');
        else fab.classList.remove('is-visible');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  });
})();
